import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

import CalculatorContext from "../../Context/CalculatorContext";

import { STEPS_PAGINATION } from "../../Constants/RouteConstants";

function StepsPagination() {
  const { currentStepIndex } = useContext(CalculatorContext);

  const navigate = useNavigate();

  return (
    <div className="form-wizard-nav justify-content-center d-flex">
      <ul className="pagination">
        {currentStepIndex > 0 && (
          <li className="page-item">
            <a
              className="page-link prev page-link-mobile-prev"
              href="#"
              onClick={(e) => {
                e.preventDefault();

                navigate(STEPS_PAGINATION[currentStepIndex - 1]);
              }}
              aria-label="Go to previous step"
            >
              <i className="icon-line-arrow-left" />
            </a>
          </li>
        )}

        {STEPS_PAGINATION.map((step, index) => {
          if (currentStepIndex > index) {
            return (
              <Link key={step} to={step}>
                <li className="page-item past">
                  <span className="page-link-custom" />
                </li>
              </Link>
            );
          }

          if (currentStepIndex === index) {
            return (
              <li key={step} className="page-item active">
                <span className="page-link-custom" />
              </li>
            );
          }

          return (
            <li key={step} className="page-item">
              <span className="page-link-custom" />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default StepsPagination;
